import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "circle-arrow-up-left-semifilled-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", transform: "matrix(-1 0 0 1 16 1)" },
        React.createElement("circle", { cx: 7.5, cy: 7.5, r: 7.5, fill: "currentColor", opacity: 0.1 }),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "m9.5 5.5-4 4" }),
        React.createElement("path", { fill: "currentColor", stroke: "currentColor", strokeLinejoin: "round", d: "M9.5 5.5v3l-3-3z" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
